// extracted by mini-css-extract-plugin
export var addButton = "_ij-0";
export var border = "_ij-8";
export var check = "_ij-h";
export var danger = "_ij-6";
export var dropdownContainer = "_ij-1";
export var editModalBody = "_ij-j";
export var footerContainer = "_ij-i";
export var fullWidth = "_ij-a";
export var hide = "_ij-9";
export var icon = "_ij-3";
export var input = "_ij-7";
export var inputFlex = "_ij-b";
export var inputWrapper = "_ij-c";
export var manualFocus = "_ij-5";
export var optionButton = "_ij-4";
export var pillWrapper = "_ij-e";
export var pointer = "_ij-2";
export var showOverflow = "_ij-f";
export var tagsFlex = "_ij-d";
export var xButton = "_ij-g";